export default __webpack_public_path__ + "static/media/background-image-login-athlete.abf466f1.jpeg";